import { api } from "./apiClient";

const teamAPI = {
  list() {
    return api.get("/team").then((r) => r.data);
  },
  invite(payload) {
    return api.post("/team/invite", payload).then((r) => r.data);
  },
  resendInvite(userId) {
    return api.post(`/team/${userId}/resend-invite`).then((r) => r.data);
  },
  updateMember(userId, payload) {
    return api.patch(`/team/${userId}`, payload).then((r) => r.data);
  },
  getMemberAudit(userId) {
    return api.get(`/team/${userId}/audit`).then((r) => r.data);
  },
  getOffboardPreview(userId) {
    return api.get(`/team/${userId}/offboard-preview`).then((r) => r.data);
  },
  offboard(userId, payload) {
    return api.post(`/team/${userId}/offboard`, payload).then((r) => r.data);
  },
  reactivate(userId) {
    return api.post(`/team/${userId}/reactivate`).then((r) => r.data);
  },
};

export default teamAPI;
